import { TYPES, FORMATS } from 'ywana-core8'

export const ARTICLE = {
    id       : { id: "id"      , column: false, type: TYPES.STRING, label: "ID"      , readOnly: true                                },
    name     : { id: "name"    , column: true , type: TYPES.STRING, label: "Name"    , required: true, visible: true, editable: true },
    category : { id: "category", column: true , type: TYPES.STRING, label: "category"    , required: true, visible: true, editable: true },
}

export const CATEGORY = {
    id       : { id: "id"      , column: false, type: TYPES.STRING, label: "ID"      , readOnly: true                                },
    name     : { id: "name"    , column: true , type: TYPES.STRING, label: "Name"    , required: true, visible: true, editable: true },
    MOQ      : { id: "MOQ"     , column: true , type: TYPES.STRING, label: "MOQ"     , required: true, visible: true, editable: true },
    horizont : { id: "horizont", column: true , type: TYPES.STRING, label: "Horizont", required: true, visible: true, editable: true },
}

export const PROD = {
    id             : { id: "id"            , type: TYPES.STRING, column: false, label: "ID"            , readOnly: true                                },
    category       : { id: "category"      , type: TYPES.STRING, column: true , label: "Category"      , required: true, visible: true, editable: true },
    TODO           : { id: "TODO"          , type: TYPES.STRING, column: true , label: "TODO"          , readOnly: true                                },
    run            : { id: "run"           , type: TYPES.STRING, column: true , label: "RUN"           , required: true, visible: true, editable: true },
    firstDate      : { id: "firstDate"     , type: TYPES.STRING, column: true , label: "firstDate"     , required: true, visible: true, editable: true },
    completionDate : { id: "completionDate", type: TYPES.STRING, column: true , label: "completionDate", required: true, visible: true, editable: true },
}

export const USER = {
    id   : { id: "id"  , type: TYPES.STRING, label: "ID"  , readOnly: true                                },
    name : { id: "name", type: TYPES.STRING, label: "Name", required: true, visible: true, editable: true },
}

export const TEAM = {
    id    : { id: "id"   , type: TYPES.STRING            , label: "ID"   , readOnly: true                                 },
    name  : { id: "name" , type: TYPES.STRING            , label: "Name" , required: true , visible: true, editable: true },
    users : { id: "users", type: TYPES.ARRAY , item: USER, label: "Users", required: false, visible: true, editable: true },
}

export const FILE = {
    id   : { id: "id"  , type: TYPES.STRING, label: "ID"  , readOnly: true                                },
    name : { id: "name", type: TYPES.STRING, label: "Name", required: true, visible: true, editable: true },
}

export const TASK = {
    id   : { id: "id"  , type: TYPES.STRING, label: "ID"  , readOnly: true                                },
    name : { id: "name", type: TYPES.STRING, label: "Name", required: true, visible: true, editable: true },
}

export const EVENT = {
    id   : { id: "id"  , type: TYPES.STRING                      , label: "ID"  , readOnly: true                                 },
    date : { id: "date", type: TYPES.STRING, format: FORMATS.DATE, label: "Date", required: true, visible: true, editable: false },
    name : { id: "name", type: TYPES.STRING                      , label: "Name", required: true, visible: true, editable: true  },
}

export const CLIENT = {
    id   : { id: "id"  , type: TYPES.STRING, label: "ID"  , readOnly: true                                },
    name : { id: "name", type: TYPES.STRING, label: "Name", required: true, visible: true, editable: true },
}

export const POST = {
    id   : { id: "id"  , type: TYPES.STRING, label: "ID"  , readOnly: true                                },
    text : { id: "text", type: TYPES.STRING, label: "Text", required: true, visible: true, editable: true },
}

export const TOPIC = {
    id       : { id: "id"      , type: TYPES.STRING            , label: "ID"      , readOnly: true                                 },
    name     : { id: "name"    , type: TYPES.STRING            , label: "Name"    , required: true , visible: true, editable: true },
    messages : { id: "messages", type: TYPES.ARRAY , item: POST, label: "Messages", required: false, visible: true, editable: true },
}

export const FORUM = {
    name   : { id: "name"   , type: TYPES.STRING              , label: "Name"  , required: true, visible: true, editable: true },
    topics : { id: "topics" , type: TYPES.ARRAY , item: TOPIC , label: "Topics", required: false, visible: true, editable: true },
}

const PROJECT_STATE_OPTIONS = [
    { label: "Planning"   , value: "PLANNING"    },
    { label: "Execution"  , value: "EXECUTION"   },
    { label: "Mantainment", value: "MANTAINMENT" },
    { label: "Finished"   , value: "FINISHED"    }
]

export const PROJECT = {
    id     : { id: "id"    , section: "MAIN"     , type: TYPES.STRING             , label: "ID"      , readOnly: true ,                               },
    name   : { id: "name"  , section: "MAIN"     , type: TYPES.STRING             , label: "Name"    , required: true , visible: true, editable: true },
    client : { id: "client", section: "MAIN"     , type: TYPES.STRING             , label: "Client"  , required: true , visible: true, editable: true },
    team   : { id: "team"  , section: "MAIN"     , type: TYPES.STRING             , label: "Team"    , required: true , visible: true, editable: true },
    state  : { id: "state" , section: "MAIN"     , type: TYPES.STRING             , label: "State"   , required: true , visible: true, editable: true , options: PROJECT_STATE_OPTIONS },
    events : { id: "events", section: "TIME LINE", type: TYPES.ARRAY , item: EVENT, label: "TimeLine", required: false, visible: true, editable: true },
    tasks  : { id: "tasks" , section: "TASKS"    , type: TYPES.ARRAY , item: TASK , label: "Tasks"   , required: false, visible: true, editable: true },
    files  : { id: "files" , section: "FILES"    , type: TYPES.ARRAY , item: FILE , label: "Files"   , required: false, visible: true, editable: true },
    forum  : { id: "forum" , section: "FORUM"    , type: TYPES.ENTITY, item: FORUM, label: "Forum"   , required: false, visible: true, editable: true },
}

export const ENVIRONMENT = {
    id       : { id: "id"      , section: ""   , type: TYPES.STRING, label: "ID"        , readOnly: true                                },
    name     : { id: "name"    , section: ""   , type: TYPES.STRING, label: "Name"      , required: true, visible: true, editable: true },
    url      : { id: "url"     , section: "Net", type: TYPES.STRING, label: "URL"       , required: true, visible: true, editable: true },
    ip       : { id: "ip"      , section: "Net", type: TYPES.STRING, label: "IP Address", required: true, visible: true, editable: true },
    port     : { id: "port"    , section: "SSH", type: TYPES.STRING, label: "Port"      , required: true, visible: true, editable: true },
    user     : { id: "user"    , section: "SSH", type: TYPES.STRING, label: "User"      , required: true, visible: true, editable: true },
    password : { id: "password", section: "SSH", type: TYPES.STRING, label: "Password"  , required: true, visible: true, editable: true },
}